import { ProductClass } from 'core/domain/benefit/productClass'
import { FamilyStatus } from 'core/domain/companies/familyStatus'

import { formatMoney } from 'common/moneyFormatter'

export const getAllowanceByFamilyStatus = (item: ProductClass, familyStatus: FamilyStatus): string => {
  return formatMoney(item.familyAllowances.find((item) => item.familyId === familyStatus)?.amount ?? 0)
}

export const getDeductiblesAmountByFamilyStatus = (item: ProductClass, familyStatus: FamilyStatus): string => {
  return formatMoney(item.familyDeductibles.find((item) => item.familyId === familyStatus)?.deductible ?? 0)
}

export const getCostSharingPercentageAmountByFamilyStatus = (
  item: ProductClass,
  familyStatus: FamilyStatus,
): number => {
  return item.familyCostSharings.find((item) => item.familyId === familyStatus)?.costSharing ?? 0
}
export const getCostSharingAmountByFamilyStatus = (item: ProductClass, familyStatus: FamilyStatus): string => {
  return formatMoney(item.familyDeductibles.find((item) => item.familyId === familyStatus)?.deductible ?? 0)
}
